import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PreviousDataService } from 'src/app/core/services/previous-gyan/previous-data.service';

@Component({
    selector: 'app-folder-list',
    templateUrl: './folder-list.component.html',
    styleUrls: ['./folder-list.component.css'],
})
export class FolderListComponent {
    @Input() folders: Array<any> = [];
    @Input() displayError: any = null;
    @Output() folderClicked = new EventEmitter<any>();

    isFolderItemHovered: { [key: number]: boolean } = {};

    constructor(private previousDataService: PreviousDataService) {}

    ngOnInit(): void {
        this.previousDataService.currentFolders.subscribe((folders: any) => {
            console.log('FolderListComponent.folders', folders);
            this.folders = folders;
        });
    }

    onFolderClick(folder: any) {
        this.folderClicked.emit(folder);
    }

    onMoveMouseEnter(index: number): void {
        this.isFolderItemHovered[index] = true;
    }

    onMoveMouseLeave(index: number): void {
        this.isFolderItemHovered[index] = false;
    }
}
